/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Showcase_Featuredgamesdetail2Inputs */

const id_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dipilih berdasarkan performa profil`)
};

const ms_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dipilih oleh prestasi profil`)
};

const da_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} udvalgt efter profilydelse`)
};

const de_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählt nach Profilleistung`)
};

const en_us2_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected by profile performance`)
};

const es_es2_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} seleccionados por rendimiento del perfil`)
};

const es_mx2_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} seleccionados por rendimiento del perfil`)
};

const fil_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pinili ayon sa performance ng profile`)
};

const fr_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sélectionnés par la performance du profil`)
};

const it_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selezionati in base alle prestazioni del profilo`)
};

const hu_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kiválasztva a profil teljesítménye alapján`)
};

const nl_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} geselecteerd op basis van profielprestaties`)
};

const no_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} valgt basert på profilens ytelse`)
};

const pl_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wybranych na podstawie wydajności profilu`)
};

const pt_br2_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selecionado por desempenho do perfil`)
};

const pt_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selecionados por desempenho do perfil`)
};

const ro_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selectate după performanța profilului`)
};

const fi_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} valittu profiilin suorituskyvyn perusteella`)
};

const sv_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} valda efter profilprestanda`)
};

const vi_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} được chọn theo hiệu suất hồ sơ`)
};

const tr_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profil performansına göre ${i?.count} seçildi`)
};

const cs_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} vybráno podle výkonu profilu`)
};

const bg_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} избрани според производителността на профила`)
};

const ru_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} выбрано по производительности профиля`)
};

const uk_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} вибрано за продуктивністю профілю`)
};

const ar_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} تم اختيارها حسب أداء الملف الشخصي`)
};

const hi_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल प्रदर्शन द्वारा ${i?.count} चयनित`)
};

const th_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} รายการที่เลือกตามประสิทธิภาพโปรไฟล์`)
};

const ja_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロフィールパフォーマンスにより ${i?.count} 件選択`)
};

const zh_cn2_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 款根据档案表现挑选的游戏`)
};

const zh_hant1_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 款根據檔案表現挑選的遊戲`)
};

const ko_profile_showcase_featuredgamesdetail2 = /** @type {(inputs: Profile_Showcase_Featuredgamesdetail2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`프로필 성과 기준 ${i?.count}개 선택됨`)
};

/**
* | output |
* | --- |
* | "{count} selected by profile performance" |
*
* @param {Profile_Showcase_Featuredgamesdetail2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_featuredgamesdetail2 = /** @type {((inputs: Profile_Showcase_Featuredgamesdetail2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Featuredgamesdetail2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "ms") return ms_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "da") return da_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "de") return de_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "fil") return fil_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "fr") return fr_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "it") return it_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "hu") return hu_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "nl") return nl_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "no") return no_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "pl") return pl_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "pt") return pt_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "ro") return ro_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "fi") return fi_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "sv") return sv_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "vi") return vi_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "tr") return tr_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "cs") return cs_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "bg") return bg_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "ru") return ru_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "uk") return uk_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "ar") return ar_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "hi") return hi_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "th") return th_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "ja") return ja_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_featuredgamesdetail2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_featuredgamesdetail2(inputs)
	return ko_profile_showcase_featuredgamesdetail2(inputs)
});
export { profile_showcase_featuredgamesdetail2 as "profile.showcase.featuredGamesDetail" }